<template>
  <div class="ruleVaccinationCreate">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        :exact="true"
        :to="{ name: 'ruleVaccination', params: {} }"
      >
        Rule Vaccination
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :to="{ name: 'ruleVaccinationCreate', params: {} }">
        Define Vaccination Rules
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card>
      <v-card-title>Define Vaccination Rules</v-card-title>
      <v-card-text>
        <ruleVaccination-form></ruleVaccination-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import RuleVaccinationForm from "./RuleVaccinationForm.vue";

export default {
  name: "ruleVaccination",
  components: {
    RuleVaccinationForm
  },
  created() {
    this.$emit("showParent", false);
  }
};
</script>
